const getClientId = () => {
  const encoded = 'NTUzOTE2MjI5MjMwLW41OTA5NXFjYTR0N2U5bDBoNjQ0YWpyMmduN2FxMHZuLmFwcHMuZ29vZ2xldXNlcmNvbnRlbnQuY29t';
  return atob(encoded);
};

export { getClientId };